@if (!hasSousMenu) {
  <div class="menu_list-first-level" routerLinkActive="is-active">
    <div class="menu_item_first-icon">
      <i [ngClass]="menuItem.iconClass" class="icon"></i>
    </div>
    <a (click)="clickMenuItem($event)" [routerLink]="menuItem.routerLink" class="menu_item_first-content" href="">
      <div class="menu_item_first-title without-sous-menu">
        <p>{{menuItem.libelle}}</p>
        <div class="menu_item_first_title-chevron is-disabled">
        </div>
      </div>
    </a>
  </div>
} @else {
  <div
    class="menu_list-first-level" (click)="switchSousMenuOpen()" [ngClass]="{'is-expanded': sousMenuOpen, 'is-active': isMenuActif()}">
    <div class="menu_item_first-icon">
      <i [ngClass]="menuItem.iconClass" class="icon"></i>
    </div>
    <div class="menu_item_first-content">
      <div class="menu_item_first-title">
        <p>{{menuItem.libelle}}</p>
        <div class="menu_item_first_title-chevron">
          <i class="icon icon-chevron-down"></i>
        </div>
      </div>
      @if (isSousMenuDisplayed) {
        <ul
          class="menu_list-second-level" [@dropdown]="stateAnimation">
          @for (sousMenu of menuItem.sousMenu; track sousMenu) {
            <li class="menu_title-second-level">
              <a href="" [routerLink]="sousMenu.routerLink" [ngClass]="{'is-active': isSousMenuActif(sousMenu)}"
                (click)="clickMenuItem($event, sousMenu)">
                {{sousMenu.libelle}}
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
}



